
const digest = '81bfb1589e9602e778a246fb0c789ab7633c2f808adce157e047b04940d6beb0';
const classes = {"wrapper":"_wrapper_1nrgr_1","leftSide":"_leftSide_1nrgr_8","count":"_count_1nrgr_13","rightSide":"_rightSide_1nrgr_21","codes":"_codes_1nrgr_28","codeWrapper":"_codeWrapper_1nrgr_37","code":"_code_1nrgr_28","viewToggle":"_viewToggle_1nrgr_49","toggleGrid":"_toggleGrid_1nrgr_56","active":"_active_1nrgr_64","toggleList":"_toggleList_1nrgr_67"};
const css = `._wrapper_1nrgr_1 {
  padding: 12px;
  display: flex;
  flex-direction: row;
  border-bottom: 1px solid #d4d7e0;
  justify-content: space-between;
}
._wrapper_1nrgr_1 ._leftSide_1nrgr_8 {
  display: flex;
  flex-direction: row;
  align-items: center;
}
._wrapper_1nrgr_1 ._leftSide_1nrgr_8 ._count_1nrgr_13 {
  color: #1d65d8;
  font-size: 14px;
  font-weight: 600;
}
._wrapper_1nrgr_1 ._leftSide_1nrgr_8 ._count_1nrgr_13 span {
  font-weight: 400;
}
._wrapper_1nrgr_1 ._rightSide_1nrgr_21 {
  display: flex;
  flex-direction: row;
  gap: 24px;
  align-items: center;
  justify-content: flex-end;
}
._wrapper_1nrgr_1 ._rightSide_1nrgr_21 ._codes_1nrgr_28 {
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 48px;
  row-gap: 10px;
  flex-wrap: wrap;
  justify-content: flex-end;
}
._wrapper_1nrgr_1 ._rightSide_1nrgr_21 ._codeWrapper_1nrgr_37 {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
}
._wrapper_1nrgr_1 ._rightSide_1nrgr_21 ._codeWrapper_1nrgr_37 ._code_1nrgr_28 {
  font-size: 14px;
}
._wrapper_1nrgr_1 ._rightSide_1nrgr_21 ._codeWrapper_1nrgr_37 ._code_1nrgr_28 span {
  font-weight: 600;
}
._wrapper_1nrgr_1 ._rightSide_1nrgr_21 ._viewToggle_1nrgr_49 {
  display: flex;
  flex-direction: row;
  gap: 15px;
  align-items: center;
  cursor: pointer;
}
._wrapper_1nrgr_1 ._rightSide_1nrgr_21 ._viewToggle_1nrgr_49 ._toggleGrid_1nrgr_56 {
  background-image: url("/dist/icons/v2/grid-solid-inactive.svg");
  background-repeat: no-repeat;
  background-size: cover;
  display: block;
  width: 17px;
  height: 17px;
}
._wrapper_1nrgr_1 ._rightSide_1nrgr_21 ._viewToggle_1nrgr_49 ._toggleGrid_1nrgr_56._active_1nrgr_64 {
  background-image: url("/dist/icons/v2/grid-solid-active.svg");
}
._wrapper_1nrgr_1 ._rightSide_1nrgr_21 ._viewToggle_1nrgr_49 ._toggleList_1nrgr_67 {
  background-image: url("/dist/icons/v2/list-solid-inactive.svg");
  background-repeat: no-repeat;
  background-size: cover;
  display: block;
  width: 17px;
  height: 17px;
}
._wrapper_1nrgr_1 ._rightSide_1nrgr_21 ._viewToggle_1nrgr_49 ._toggleList_1nrgr_67._active_1nrgr_64 {
  background-image: url("/dist/icons/v2/list-solid-active.svg");
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  